export const ISLIVE = process.env.REACT_APP_IS_LIVE === '1'

export const BaseUrls: any = {
	S3_BASE_URL : {
		url: ISLIVE ? process.env.REACT_APP_S3_BUCKET_URL_LIVE : process.env.REACT_APP_S3_BUCKET_URL_UAT
	},
	COMMUNITY_HEALTH_CAMP_SERVER : {
		url: ISLIVE ? process.env.REACT_APP_API_BASE_URL_LIVE : process.env.REACT_APP_API_BASE_URL_UAT
	},
    REACT_APP_API_SURVEY_UAT: {
        url: ISLIVE ? process.env.REACT_APP_API_SURVEY_PYTHON_UAT : process.env.REACT_APP_API_SURVEY_PYTHON_UAT
    }
}

export const ENC_KEY_STRING = process.env.REACT_APP_ENCRYPTION_KEY || '';
export const IV_STRING = process.env.REACT_APP_ENCRYPTION_IV;